<template>
  <div>
    <div class="dialog-header">
      <el-button @click="funcFilter">
        查询
      </el-button>
    </div>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="360"
      :data="tableData"
      :loading="loading"
      :checkbox-config="{ highlight: true }"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          min-width="130"
          field="userName"
          title="姓名"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.userName"
            placeholder="请输入姓名"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column min-width="130" field="phone" title="电话" sortable />
        <template v-slot:header>
          <el-input
            v-model="listQuery.phone"
            placeholder="请输入电话"
            clearable
          />
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <div slot="footer" class="dialog-footer">
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button type="primary" @click="funcSubmit('select')">
        推 送
      </el-button>
      <el-button type="primary" @click="funcSubmit('all')">
        全部推送
      </el-button>
    </div>
  </div>
</template>
<script>
import { getShipperList } from "@/api/shipment";
import { pushNoticeOrSendSMS } from "@/api/news";
export default {
  name: "NoteManagePushShipper",
  data() {
    return {
      loading: false,
      tableData: [],
      emptyListQueryString: "",
      listQuery: {
        staffTypes: "0, 1",
        userName: "",
        phone: "",
        noticCode: "",
        noticeType: 1,
        sendType: 1,
        allflag: 0,
        partyCodes: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      Pagingconf: [],
      // 机构列表
      branchList: this.$store.state.components.branchList
    };
  },
  created() {
    this.emptyListQueryString = JSON.stringify(this.listQuery);
  },
  methods: {
    findList(code) {
      this.loading = true;
      if (code) {
        this.listQuery.noticCode = code;
      }
      getShipperList(this.listQuery).then(response => {
        this.tableData = response.data.records;
        this.listQuery.total = response.data.total;
        response.data.total > 10000
          ? (this.Pagingconf = [20, 30, 50, 100, 10000])
          : (this.Pagingconf = [20, 30, 50, 100, response.data.total || 1]);
        this.loading = false;
      });
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },
    // 全部推送/部分推送
    funcSubmit(type) {
      if (type === "all") {
        this.listQuery.allflag = 1;
        this.listQuery.partyCodes = "";
      } else {
        const checkedRowArray = this.$refs.xTable.getSelectRecords();
        if (!checkedRowArray || checkedRowArray.length === 0) {
          this.$message({ message: "请选择推送的托运人", type: "warning" });
          return false;
        }
        this.listQuery.allflag = 0;
        this.listQuery.partyCodes = checkedRowArray
          .map(item => item.partyCode)
          .join(",");
      }
      const rLoading = this.openLoading();
      pushNoticeOrSendSMS(this.listQuery).then(response => {
        rLoading.close();
        this.$message({ message: "推送成功", type: "success" });
        this.listQuery = JSON.parse(this.emptyListQueryString);
        this.$emit("fatherComplete");
      });
    },
    // 取消
    funcCancel() {
      this.listQuery = JSON.parse(this.emptyListQueryString);
      this.$emit("fatherComplete");
    }
  }
};
</script>

<style>
.dialog-header {
  padding-bottom: 10px;
}
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 300px;
  float: right;
}
</style>
